<div class="date-select-container">
  <mat-form-field appearance="outline" style="width: 100%;">
    <mat-label *ngIf="label">{{ label }}</mat-label>
    
    <input 
      matInput 
      [matDatepicker]="picker" 
      [disabled]="disabled" 
      [required]="required"
      [min]="minDate"
      [max]="maxDate"
      [value]="selectedDate"
      (dateChange)="onDateChange($event.value)"
      (focus)="isFocused = true"
      (blur)="isFocused = false; onTouched()"
      [placeholder]="isFocused ? placeholder : ''">
      
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</div>